import { render, staticRenderFns } from "./CustomerUserAutocomplete.vue?vue&type=template&id=73ffd37a&"
import script from "./CustomerUserAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CustomerUserAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports